<script setup>
import IconChevronDown from '../icon/IconChevronDown.vue'
import IconBase from '../icon/IconBase.vue'
import FormButton from './FormButton.vue'

const isOpen = defineModel('isOpen', { type: Boolean, default: false })

defineProps({
  header: {
    type: String,
    default: ''
  },
  headerClasses: {
    type: String,
    default: '!px-2 !py-1 bg-surface-3 text-tiny'
  },
  contentClasses: {
    type: String,
    default: '!p-2 bg-surface-3 rounded-b-lg'
  },
  collapseWrapperClasses: {
    type: String,
    default: ''
  },
  initialAnimation: {
    type: Boolean,
    default: false
  }
})

const toggleView = () => {
  isOpen.value = !isOpen.value
}

defineExpose({ toggleView, isOpen, isVisible: isOpen })
</script>
<template>
  <section :class="collapseWrapperClasses">
    <header class="flex items-center justify-between" :class="[headerClasses, isOpen ? '!rounded-t-lg' : '!rounded-lg']">
      <slot name="header" />
      <h3 v-if="header" class="text-base font-medium">{{ header }}</h3>
      <FormButton type="link" size="sm" is-icon @click="toggleView">
        <icon-base class="shrink-0 text-surface-8" :class="{ 'rotate-180': isOpen }">
          <IconChevronDown /> 
        </icon-base>
      </FormButton>
    </header>
    <div v-if="isOpen" class="" :class="contentClasses">
      <slot name="content" />
    </div>
  </section>
</template>

<style scoped>
/* Removed previous CSS animations as they're now handled by Tailwind */
:deep(.multiselect__tags) {
  @apply bg-surface-4
}
</style>